import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ZoomInIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M6.18207 16.6109C4.94934 15.0706 4.20703 13.1216 4.20703 11C4.20703 6.0376 8.24463 2 13.207 2C18.1694 2 22.207 6.0376 22.207 11C22.207 15.9624 18.1694 20 13.207 20C11.0854 20 9.13641 19.2577 7.59613 18.025L3.41406 22.207L2 20.793L6.18207 16.6109ZM13.207 18C17.0669 18 20.207 14.8599 20.207 11C20.207 7.14014 17.0634 4 13.2035 4C9.34365 4 6.20703 7.14014 6.20703 11C6.20703 14.8599 9.34717 18 13.207 18Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M12.2 12H10.2V11V10H12.2V8H13.2035H14.2V10H16.2V11V12H14.2V14H12.2V12Z",
    fill: "currentColor"
  }));
}